import artifactProductionStatuses from "astrid-firestore/src/api/artifacts/constants/artifactProductionStatuses";

export default function getArtifactProductionStatus({ artifact }) {
	// An artifact is considered delivered if it was produced by someone
	// and not just uploaded by a user directly to an article or work
	if (artifact?.producer && (artifact?.work || artifact?.article)) {
		return artifactProductionStatuses.DELIVERED;
	}

	return artifactProductionStatuses.NOT_DELIVERED;
}
